import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle } from 'lucide-react';
export function Benefits() {
  const includes = ['Ebook principal: Cómo vender en Amazon FBA desde cero (2026)', 'Bono #1: Lista de productos listos para vender', 'Bono #2: Plantilla premium para encontrar productos ganadores', 'Bono #3: Checklist completo para lanzar sin errores'];
  const transformation = ['Entender cómo funciona Amazon sin confusión', 'Tener claridad sobre qué productos vender', 'Dar tu primer paso hacia ingresos online', 'Dejar de perder tiempo en información suelta', 'Construir algo real desde casa'];
  return <section className="bg-brand-white py-20 px-6" data-id="element-13">
      <div className="max-w-3xl mx-auto" data-id="element-14">
        {/* Qué incluye */}
        <FadeIn data-id="element-15">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-brand-green mb-12" data-id="element-16">
            ¿QUÉ INCLUYE TU COMPRA?
          </h2>
        </FadeIn>

        <div className="bg-brand-beige rounded-3xl p-8 md:p-12 mb-8" data-id="element-17">
          <div className="space-y-6" data-id="element-18">
            {includes.map((item, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-19">
                <div className="flex items-center gap-4" data-id="element-20">
                  <CheckCircle className="w-6 h-6 text-brand-green flex-shrink-0" data-id="element-21" />
                  <p className="text-xl text-brand-text font-medium" data-id="element-22">{item}</p>
                </div>
              </FadeIn>)}
          </div>
        </div>

        <FadeIn delay={0.5} data-id="element-23">
          <p className="text-lg text-brand-text/80 text-center mb-20" data-id="element-24">
            No solo aprenderás… Tendrás herramientas listas para aplicar desde
            el primer día y evitar errores que hacen perder dinero.
          </p>
        </FadeIn>

        {/* Transformación */}
        <FadeIn delay={0.6} data-id="element-25">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-brand-green mb-12" data-id="element-26">
            DESPUÉS DE ESTE SISTEMA PODRÁS:
          </h2>
        </FadeIn>

        <div className="bg-brand-beige rounded-3xl p-8 md:p-12" data-id="element-27">
          <div className="space-y-6" data-id="element-28">
            {transformation.map((item, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-29">
                <div className="flex items-center gap-4" data-id="element-30">
                  <CheckCircle className="w-6 h-6 text-brand-green flex-shrink-0" data-id="element-31" />
                  <p className="text-xl text-brand-text font-medium" data-id="element-32">{item}</p>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}